(function () {
'use strict';

angular
.module('app.performanceReportTierPerformance')
.controller('performanceReportTierPerformanceCtrl',
    ['$scope', '$rootScope', 'measureService', 'performanceReportTierPerformanceService','$http', '$controller', 
    function ($scope, $rootScope, measureService, performanceReportTierPerformanceService, $http, $controller){
        $scope.currentUser = $rootScope.currentUser;
        $scope.tierPerformance = [];
       
        //Watch on change keyword / blog / project change
        $scope.$on('refreshDashboard', function(event, args) {
            getDataTierPerformanceReport();
        });

        function getDataTierPerformanceReport() {
            var params = $rootScope.saveParams;
            if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
                return;
            } 
            params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

            getTierPerformance(params);
        }

        function getTierPerformance(params) {
            params.company_id = $rootScope.advertiserID;

            if($scope.currentUser.role.accessLevel == 'admin' || $scope.currentUser.role.accessLevel == 'agency') {
                params.company_id = $rootScope.sideMenuSelections.advertiserId;
            }
            
            if($scope.currentUser.role.accessLevel == 'advertiser') {
                params.company_id = $scope.currentUser.company.id;
            }

            performanceReportTierPerformanceService.getTierPerformanceData(params)
                .then(function(result){
                    $scope.tierPerformance = result.data;
                })
                .catch(function(message){
                    $scope.tierPerformance = [];
                })
                .finally(function(){
                    $rootScope.$broadcast('sectionLoaded');
                });
        }

        // first initiating
        getDataTierPerformanceReport();

        $scope.triangleHeight = function(value) {
            var val = 105*value + "px";
            return {"height": val};
        }

        $scope.triangleBorderHeight = function(value) {
            var val = 105*value + "px solid white";
            return {"border-top": val};
        }
    }]);
})();